export const emailRequestStatus = {
  InProgress: 0,
  NotFound: 1,
  PendingVerification: 2,
  BadEmail: 3,
  Success: 4,
};
